import type {
  NumberInputFieldProps,
  NumberInputProps} from '@chakra-ui/react'
import {
  InputGroup,
  InputRightElement,
  NumberInput,
  NumberInputField
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'

import { usePriceFormat } from '@/hooks/usePriceFormat'

interface CustomNumberInputProps extends Omit<NumberInputProps, 'defaultValue'> {
  onValueChange?: (value: string, valueAsNumber?: number) => void
  defaultValue?: number | undefined | null
  inputRightElement?: string | React.ReactNode | null
  inputProps?: NumberInputFieldProps
}

export const CustomNumberInput = React.forwardRef(({
  onValueChange,
  defaultValue,
  inputRightElement,
  inputProps,
  ...rest
}: CustomNumberInputProps, ref
) => {
  const { currencyUnit } = usePriceFormat()
  // an omitted suffix means "money" and follows the market currency;
  // an explicit null/'' still hides it
  const rightElement = inputRightElement === undefined ? currencyUnit : inputRightElement
  const [value, setValue] = useState(defaultValue)
  const format = (val: number | undefined) => val !== undefined ? new Intl.NumberFormat('cs-CZ').format(Number(val)) : ''
  const parse = (val: number | undefined) => val !== undefined ? String(val).replace(/ /, '') : ''

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <InputGroup>
      <NumberInput
        ref={ref}
        value={format(value ?? undefined)}
        // defaultValue={format(value)}
        focusInputOnChange={false}
        onChange={(valueAsString: string, valueAsNumber: number) => {
          const val = isNaN(valueAsNumber) ? undefined : valueAsNumber
          setValue(val)
          onValueChange?.(val ? parse(val) : '', val)
        }}
        {...rest}
      >
        <NumberInputField maxW={128} minW='100%' {...inputProps} />

        {rightElement && <InputRightElement>{rightElement}</InputRightElement>}
      </NumberInput>
    </InputGroup>
  )
}
)